import { FEATURE_ROUTES } from "../../../config/navigation";
import React from "react";
import { Link, useLocation } from "react-router-dom";

const isActive = (pathname, path, exact = false) => {
  return exact ? pathname === path : pathname.indexOf(path) === 0;
};

const StorageMenu = () => {
  const { pathname } = useLocation();
  const reportsVisible = isActive(pathname, "/operations/storage/reports");

  return (
    <div className="uk-margin-bottom">
      <ul className="uk-tab uk-margin-remove-bottom uk-margin-small-right rbr-inspection-tabs">
        <li className={isActive(pathname, "/operations/storage", true) ? "uk-active" : ""}>
          <Link to="/operations/storage">Overview</Link>
        </li>
        <li className={isActive(pathname, "/operations/storage/stock") ? "uk-active" : ""}>
          <Link to={FEATURE_ROUTES.stock}>Stock</Link>
        </li>
        <li className={isActive(pathname, "/operations/storage/movements") ? "uk-active" : ""}>
          <Link to={FEATURE_ROUTES.movements}>Movements</Link>
        </li>
        <li className={isActive(pathname, "/operations/storage/items") ? "uk-active" : ""}>
          <Link to={FEATURE_ROUTES.items}>Items</Link>
        </li>
        <li className={isActive(pathname, "/operations/storage/locations") ? "uk-active" : ""}>
          <Link to={FEATURE_ROUTES.locations}>Locations</Link>
        </li>
        <li className={reportsVisible ? "uk-active" : ""}>
          <Link to={FEATURE_ROUTES.inventoryValue}>Reports</Link>
        </li>
      </ul>
      {reportsVisible && (
        <ul className="uk-tab uk-margin-small-top uk-margin-remove-bottom uk-margin-small-right rbr-inspection-tabs">
          <li className={isActive(pathname, "/operations/storage/reports/value") ? "uk-active" : ""}>
            <Link to={FEATURE_ROUTES.inventoryValue}>Value Report</Link>
          </li>
          <li className={isActive(pathname, "/operations/storage/reports/loss") ? "uk-active" : ""}>
            <Link to={FEATURE_ROUTES.inventoryLoss}>Loss Report</Link>
          </li>
          <li className={isActive(pathname, "/operations/storage/reports/low-stock") ? "uk-active" : ""}>
            <Link to={FEATURE_ROUTES.lowStock}>Low Stock Report</Link>
          </li>
        </ul>
      )}
    </div>
  );
};

export default StorageMenu;
